// extracted by mini-css-extract-plugin
module.exports = {"customSelectSearch":"Index_customSelectSearch__MiC2J","wrapper":"Index_wrapper__bUxx2"};